<div class="flex flex-col flex-auto min-w-0" #pageContainer>
    <div role="tablist" class="tabs tabs-boxed w-2/4 mt-2 mb-12">
        <a role="tab" class="tab primary-tab-active"> Field Summary </a>
        <a role="tab" class="tab" (click)="toStringSummary()">
            String Summary
        </a>
    </div>

    <div class="w-full grid grid-cols-1">
        <form [formGroup]="searchForm">
            <div class="grid grid-cols-2 gap-2">
                <div class="flex justify-start">
                    <div class="w-20 mx-2">
                        <mat-form-field class="w-full">
                            <mat-select formControlName="PageSize">
                                <mat-option [value]="10"> 10 </mat-option>
                                <mat-option [value]="20"> 20 </mat-option>
                                <mat-option [value]="50"> 50 </mat-option>
                                <mat-option [value]="100"> 100 </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <button
                        class="group btn btn-outline btn-default dt-download mx-2"
                        [matMenuTriggerFor]="downloadMenu"
                    >
                        <mat-icon
                            class="text-primary group-hover:text-white"
                            svgIcon="heroicons_solid:arrow-down-tray"
                        ></mat-icon>
                    </button>
                    <mat-menu #downloadMenu="matMenu">
                        <button
                            mat-menu-item
                            (click)="downloadFieldsSummaryExcel()"
                        >
                            Excel
                        </button>
                    </mat-menu>
                </div>
                <div class="flex justify-end">
                    <button
                        class="group btn btn-outline btn-default mx-2 hover:text-white"
                        (click)="fetchFieldSummaryData()"
                    >
                        <mat-icon
                            class="text-primary group-hover:text-white"
                            svgIcon="heroicons_solid:arrow-path"
                        ></mat-icon>
                    </button>
                </div>
            </div>
        </form>

        <div class="grid overflow-x-auto">
            <!-- Header -->
            <div
                class="table-wh-field-summary-grid z-10 sticky top-0 grid shadow text-md font-semibold text-white bg-primary dark:bg-black dark:bg-opacity-5"
                matSort
                matSortDisableClear
            >
                <div class="border py-8 text-center"></div>

                <div class="border py-8 text-center">No</div>

                <div
                    [mat-sort-header]="'fieldLongName'"
                    class="flex justify-center border py-8"
                >
                    Field Name
                </div>

                <div
                    [mat-sort-header]="'pmCompleteness'"
                    class="flex justify-center border py-4"
                >
                    Healthy %
                </div>

                <div class="block col-span-2 text-center border pt-4">
                    Healthy

                    <div class="grid grid-cols-2 text-sm font-bold mt-3">
                        <div class="border text-center py-2 bgCompleted">
                            Healthy
                        </div>
                        <div class="border text-center py-2 bgPending">
                            Healthy with MOC
                        </div>
                    </div>
                </div>

                <div class="block col-span-3 text-center border pt-4">
                    Unhealthy

                    <div class="grid grid-cols-3 text-sm font-bold mt-3">
                        <div class="border text-center py-2 bgCompleted">
                            Unhealthy
                        </div>
                        <div class="border text-center py-2 bgPending">
                            Unhealthy with MOC
                        </div>
                        <div class="border text-center py-2 bgPending">
                            Unhealthy with High Risk
                        </div>
                    </div>
                </div>
            </div>
            <!-- Rows -->
            <ng-container *ngIf="dt.rows.length; else noRecords">
                <ng-container
                    *ngFor="let row of dt.rows; let i = index; trackBy: trackByFn;"
                >
                    <div
                        class="table-wh-field-summary-grid grid items-center border-b"
                        [ngClass]="{'bg-primary-100': i % 2 }"
                    >
                        <!-- Expand Icon -->
                        <button
                            class="py-4 text-center cursor-pointer bg-transparent border-0 p-0"
                            (click)="toggleExpandRow(row)"
                            type="button"
                            aria-label="Toggle expand row"
                        >
                            <mat-icon
                                [svgIcon]="row.expanded ? 'heroicons_mini:minus' : 'heroicons_mini:plus'"
                            ></mat-icon>
                        </button>

                        <!-- No -->
                        <div class="py-4 text-center">
                            {{startingIndex + i + 1}}.
                        </div>

                        <!-- Field Long Name -->
                        <div class="flex truncate justify-center">
                            {{ row.fieldName }}
                        </div>

                        <!-- PM Completeness Percentage  -->
                        <div class="flex justify-center px-4">
                            <div class="progress-container">
                                <div
                                    class="progress-bar"
                                    [style.width.%]="row.healthyPercentage"
                                >
                                    {{ row.healthyPercentage }}%
                                </div>
                            </div>
                        </div>

                        <!-- Healthy -->
                        <div class="block text-center">{{ row.healthy }}</div>
                        <div class="block text-center">
                            {{ row.healthyMoc }}
                        </div>

                        <!-- Unhealthy -->
                        <div class="block text-center">{{ row.unhealthy }}</div>
                        <div class="block text-center">
                            {{ row.unhealthyMoc }}
                        </div>
                        <div class="block text-center">
                            {{ row.unhealthyHighRisk }}
                        </div>
                    </div>

                    <!-- Expand Row -->
                    <div
                        *ngIf="row.expanded"
                        class="table-wh-field-summary-grid grid items-center border-b"
                        [ngClass]="{'bg-primary-100': i % 2 }"
                    >
                        <ng-container
                            *ngFor="let rowChild of row.list; let i = index; trackBy: trackByFn;"
                        >
                            <div class="my-5"></div>
                            <div></div>

                            <!-- Field Long Name -->
                            <div class="flex truncate justify-center">
                                {{ rowChild.platformLongName }}
                            </div>

                            <!-- PM Completeness Percentage  -->
                            <div class="flex justify-center px-4">
                                <div class="progress-container">
                                    <div
                                        class="progress-bar"
                                        [style.width.%]="rowChild.healthyPercentage"
                                    >
                                        {{ rowChild.healthyPercentage }}%
                                    </div>
                                </div>
                            </div>

                            <!-- Healthy -->
                            <div class="block text-center">
                                {{ rowChild.healthyCount }}
                            </div>
                            <div class="block text-center">
                                {{ rowChild.healthyWithMocCount }}
                            </div>

                            <!-- Unhealthy -->
                            <div class="block text-center">
                                {{ rowChild.unhealthyCount }}
                            </div>
                            <div class="block text-center">
                                {{ rowChild.unhealthyWithMocCount }}
                            </div>
                            <div class="block text-center">
                                {{ rowChild.unhealthyWithHighRiskCount }}
                            </div>
                        </ng-container>
                    </div>
                </ng-container>
            </ng-container>

            <ng-template #noRecords>
                <div
                    class="p-8 sm:p-16 text-2xl sm:text-2xl font-semibold tracking-tight text-center"
                >
                    There are no Records registered!
                </div>
            </ng-template>
        </div>
    </div>

    <div role="tablist" class="tabs tabs-boxed w-2/4 my-12">
        <a
            role="tab"
            class="tab"
            [ngClass]="{ 'primary-tab-active': isWhCategory }"
            (click)="isWhCategory = true"
        >
            By WH Category
        </a>
        <a
            role="tab"
            class="tab"
            [ngClass]="{ 'primary-tab-active': !isWhCategory }"
            (click)="isWhCategory = false"
        >
            By Prod Category
        </a>
    </div>

    <div class="w-full grid grid-cols-1" *ngIf="isWhCategory">
        <app-well-wh-category [data]="whCategoryData"></app-well-wh-category>
    </div>

    <div class="w-full grid grid-cols-1" *ngIf="!isWhCategory">
        <app-well-prod-category
            [data]="prodCategoryData"
        ></app-well-prod-category>
    </div>
</div>
